import * as React from "react";
import { connect } from "react-redux";

import State from "../../screens/Settings/State";
import {
  addState,
  stateViewList,
  deleteState,
  editState,
  stateSearch,
  stateSlectedPage,
} from "./action";
class StateContainer extends React.Component<Props, State> {
  render() {
    return (
      <State
        stateViewList={this.props.stateViewList}
        addState={this.props.addState}
        stateList={this.props.stateList}
        deleteState={this.props.deleteState}
        editState={this.props.editState}
        stateDtlsCount={this.props.stateDtlsCount}
        stateSearchList={this.props.stateSearchList}
        stateSearch={this.props.stateSearch}
        stateSlectedPage={this.props.stateSlectedPage}
        statesSearchCount={this.props.statesSearchCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    stateViewList: () => {
      dispatch(stateViewList());
    },
    addState: (value) => {
      dispatch(addState(value));
    },
    deleteState: (items) => {
    
      dispatch(deleteState(items));
    },
    editState: (value) => {
    
      dispatch(editState(value));
    },
    stateSearch: (value) => {
     
      dispatch(stateSearch(value));
    },
    stateSlectedPage: (value) => {
    
      dispatch(stateSlectedPage(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    stateList: state.StateReducer.stateList,
    stateDtlsCount: state.StateReducer.stateDtlsCount,
    stateSearchList: state.StateReducer.stateSearchList,
    statesSearchCount: state.StateReducer.statesSearchCount,
  };
}

export default connect(mapStateToProps, bindAction)(StateContainer);
